export default "__VITE_ASSET__BpMZ3i0A__"